module.exports = __webpack_public_path__ + "img/rolling10ex_icon.8b71f037.png";